import axios from "axios"
import {
    APIpath,
    addToast
} from '../actions'

export const storeContact = (values) => (dispatch) => {

    axios.post(`${APIpath}/contact/store`, values)
        .then(function (response) {
            dispatch(addToast('success', 'Envio realizado con éxito'))
        })
        .catch(function (err) {
            dispatch(addToast('error', 'El proceso ha fallado'))
        })
}

export const storeReclamo = (values) => (dispatch) => {

    axios.post(`${APIpath}/reclamo/store`, values, { headers: { "Content-Type": "multipart/form-data" } })
        .then(function (response) {
            //dispatch(addToast('success', 'Envio realizado con éxito'))
        })
        .catch(function (err) {
            //dispatch(addToast('error', 'El proceso ha fallado'))
        })

}